
import {Component, Vue} from 'vue-property-decorator';
import Icon from '@/components/Icon.vue';

@Component({
  components: {Icon}
})
export default class Nav extends Vue {
  tabs = [
    {'id': '1', 'pathTo': '/labels', 'iconName': 'bills', 'title': '标签'},
    {'id': '2', 'pathTo': '/money', 'iconName': 'account', 'title': '记账'},
    {'id': '3', 'pathTo': '/statistics', 'iconName': 'statistics', 'title': '统计'}];
}
